import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://inweleursyulyllmzoca.supabase.co"
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlud2VsZXVyc3l1bHlsbG16b2NhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0MTM4ODEsImV4cCI6MjA1Nzk4OTg4MX0.mNY9GIc7uyQRiRRvOGGNTaEKB9c6FrV81OmcgVuLet0"

if (!supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable')
}

if (!supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Simplified admin authentication - any authenticated user gets admin access
export const adminAuth = {
  async signIn(email: string, password: string) {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      })

      if (error) throw error

      // All authenticated users get admin access
      return { 
        user: data.user, 
        session: data.session,
        admin: { 
          email, 
          role: 'admin',
          id: data.user.id,
          is_active: true
        },
        accessLevel: 'admin'
      }
    } catch (error) {
      console.error('Admin sign in error:', error)
      throw error
    }
  },

  async signOut() {
    try {
      const { error } = await supabase.auth.signOut()
      if (error) throw error
    } catch (error) {
      console.error('Admin sign out error:', error)
    }
  },

  async getCurrentUser() {
    try {
      const { data } = await supabase.auth.getUser()
      const { user } = data
      
      if (!user) return null

      // All authenticated users get admin access
      return { 
        user, 
        session: null, // Fixed: session is not available from getUser()
        admin: { 
          email: user.email, 
          role: 'admin',
          id: user.id,
          is_active: true
        },
        accessLevel: 'admin'
      }
    } catch (error) {
      console.error('Get current user error:', error)
      return null
    }
  },

  // User registration
  async signUp(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    })

    if (error) throw error

    return data
  }
}

// Simplified permissions - all authenticated users have full access
export const permissions = {
  canViewBookings: () => true,
  canEditBookings: () => true,
  canDeleteBookings: () => true,
  canCreateBookings: () => true,
  canManageCalendar: () => true,
  canViewReports: () => true,
  canManageUsers: () => true,
  canViewDashboard: () => true,
}